<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import AdjustOptionMarginModal from './AdjustOptionMarginModal.vue';

const emits = defineEmits<{ saveAdjustOptionMargin: [value: any] }>();

const { t } = useI18n({ useScope: 'global' });
const dialog = useDialog();

const openAdjustOptionMargin = () => {
  dialog.open(AdjustOptionMarginModal, {
    data: {
      isTourModal: true
    },
    props: {
      header: t('worksheet.adjust_option_margin'),
      maximizable: true,
      style: {
        width: '30vw'
      },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      modal: true
    },
    emits: {
      onApply: (data: any) => {
        emits('saveAdjustOptionMargin', data);
      }
    }
  });
};
</script>
<template>
  <div>
    <Button id="adjust-margin-btn" size="small" severity="danger" class="custom-button uppercase" @click="openAdjustOptionMargin()">{{ $t('worksheet.adjust_option_margin') }}</Button>
  </div>
</template>
